{
  "401": {
    "title": "Authentication error",
    "description": "We're sorry, but the resource you're trying to access is currently unavailable. Access to NTU is not authorized without an assigned role, please contact your administrator."
  },
  "500": {
    "title": "Technical error",
    "description": "A temporary error prevents us from loading this page. Please try again in a moment.",
    "retry": "Try again"
  },
  "files": "Files",
  "attendees_list": "Attendees list",
  "attendees": "Attendees",
  "attachments": "Attachments",
  "attendee_attachments": "Attachments - Attendees",
  "enable": "Enable",
  "disable": "Disable",
  "selected": "selected",
  "products": "Products",
  "regions": "Regions",
  "sectors": "Sectors",
  "zones": "Zones",
  "identities": "Entities",
  "ugas": "UGAS",
  "networks": "Networks",
  "therapeuticAreas": "Therapeutic areas",
  "units": "Services",
  "contacts": "Contacts",
  "specialties": "Specialties",
  "internal_signers": "Internal signers",
  "users": "Users",
  "attachments_template": "Attachment templates",
  "admin": "Admin",
  "logout": "Logout",
  "none": "None",
  "profile": "Profile",
  "save": "Save",
  "undo": "Undo",
  "clear_canvas": "Clear canvas",
  "step_number": "Step {number}",
  "warning": "Careful !",
  "error": "Error",
  "delete": "Delete",
  "next": "Next",
  "validate": "Validate",
  "cancel": "Cancel",
  "clone": "Clone",
  "clone_modal": {
    "title": "Clone the ticket",
    "description": "Select the additional data to clone:",
    "indications_default": "The information of the \"Indications\" section will be duplicated by default",
    "inputs": {
      "packages": "Packages",
      "attendees": "Attendees",
      "attachments": "Attachments",
      "packages_assignations": "Packages assignations"
    }
  },
  "trash_modal": {
    "title": "Cancellation confirmation",
    "description": "Are you sure you want to delete the ticket:\n",
    "button": "Confirm cancellation"
  },
  "clear": "clear",
  "apply": "Apply",
  "to_edit": "Edit",
  "edit": "Edit",
  "no_data": "No data",
  "select_all": "Select all",
  "remove_all": "Remove all",
  "results": "results",
  "no_results": "No results",
  "result": "result",
  "archived": "To archive",
  "add": "Add",
  "modify": "Modify",
  "assign": "Assign",
  "backward": "Back",
  "on": "on",
  "contract": "Contract",
  "document": "Document",
  "create_and_save": "Create and save",
  "to_save": "Save",
  "drag_and_drop_statement": "Please select a file or drag and drop here",
  "no_elements": "No elements",
  "back_to_home": "Back to the dashboard",
  "back_to_edit": "Back to the edit",
  "back_to_deposit_management": "Back to the deposit management",
  "selected_entity_placeholder": {
    "attendee": "attendee"
  },
  "errors": {
    "401": {
      "title": "Authentication error",
      "content": "Your session has expired, please reconnect."
    },
    "403": "You don't have the rights to access this page"
  },
  "search": {
    "placeholder": {
      "users": "Search a user"
    },
    "search_in": "I search in",
    "one": "a/an",
    "result_by": {
      "label": "Search result on {by}",
      "contact": "the contacts",
      "veeva": "Veeva",
      "health_directory": "the ANS",
      "one_key": "One key"
    }
  },
  "access_denied": "Access denied",
  "not_found": {
    "title": "Resource not found",
    "description": "We're sorry, but the resource you're trying to access is currently unavailable.",
    "redirect": "Go back to the previous page"
  },
  "modal": {
    "button": {
      "close": "Close"
    }
  },
  "select": {
    "placeholder": "Select an option",
    "disabled": "Option disabled",
    "na": "N/A",
    "groups": {
      "enabled": "Active",
      "disabled": "Inactive"
    }
  },
  "button": {
    "add": "Add",
    "add_attendee_list": "Add Attendee's List",
    "download_attendee_template": "Download template"
  },
  "loader_text": {
    "contract_template": {
      "immediate": "Upload of your template",
      "indeterminate": {
        "waiting_server": "Waiting for the server",
        "compression": "Compressing the file",
        "connecting": "Connecting to the server"
      }
    },
    "expense_report": {
      "immediate": "Upload of your Expense Report",
      "indeterminate": {
        "waiting_server": "Waiting for the server",
        "compression": "Compressing the file",
        "connecting": "Connecting to the server"
      }
    },
    "signing_sheet": {
      "immediate": "Upload of your Signing Sheet",
      "indeterminate": {
        "waiting_server": "Waiting for the server",
        "compression": "Compressing the file",
        "connecting": "Connecting to the server"
      }
    },
    "non_compliance": {
      "immediate": "Create your non compliance",
      "indeterminate": {
        "waiting_server": "Waiting for the server",
        "compression": "Creating",
        "connecting": "Connecting to the server"
      }
    },
    "default": "Loading..."
  },
  "dashboard": {
    "title": "Welcome to your",
    "declaration_space": "Dashboard",
    "create_event": "Create event",
    "back_to_dashboard": "Back to dashboard",
    "type": {
      "list": "List",
      "column": "Column"
    },
    "list_header": {
      "name": "Last name",
      "event_type": "Type",
      "contractor": "Contractor",
      "operation": "Operation",
      "start_at_end_at": "Dates",
      "code": "Reference",
      "created_by": "Creator",
      "initiator": "Initiator",
      "validator_1": "Validator 1",
      "validator_2": "Validator 2",
      "action": "Action",
      "regime": "Regime",
      "remaining_days": "Delay"
    },
    "status": {
      "creating": "Being created",
      "to_edit": "To modify",
      "canceled": "Canceled"
    },
    "workflow": {
      "first_validation": "First validation",
      "second_validation": "Second validation",
      "contract_management_stage": "Contract management",
      "event_in_progress": "Event in progress",
      "event_validating": "Expenses validation",
      "event_is_finished": "Event is finished"
    },
    "workflow_step": {
      "creating": "Creating",
      "to_edit": "To Edit",
      "first_validation": "First validation",
      "second_validation": "Second validation",
      "validating": "Validating",
      "contract_management": "In submission & management",
      "event_in_progress": "Event in progress",
      "event_validating": "Expenses validation",
      "event_is_finished": "Event is finished",
      "library": "Library",
      "transparency": "Transparency",
      "canceled": "Canceled"
    },
    "filters": {
      "title": "Filter",
      "status": "Status",
      "apply": "Apply",
      "reset": "Reset",
      "pending_action": "Pending actions",
      "my_tickets": "I'm the creator",
      "my_tickets_to_validate": "I'm the validator",
      "show": "Show filters",
      "hide": "Hide filters"
    },
    "ticket": {
      "contracts": "{signed_contracts}/{eligible_attendees_count} contracts signed",
      "generated_contracts": "{generated_contracts}/{eligible_attendees_count} contracts generated",
      "deposits": "{deposit_sent}/{eligible_deposits_count} deposits sent",
      "advantage": {
        "completed": "Spending completed",
        "not_validated": "Spending denied"
      }
    }
  },
  "library": {
    "title": "Library",
    "to_declare": "Transparency",
    "remove_selected_ticket": "Remove selected",
    "management": "Management",
    "ticket_management": "Library management",
    "reports": "Reports"
  },
  "sidebar": {
    "cta": "New Event",
    "collapse": "Collapse sidebar",
    "sections": {
      "tickets": "Tickets"
    },
    "links": {
      "contract_management": "Contract management",
      "dashboard": "Dashboard",
      "library": "Library",
      "library_to_declare": "Transparency",
      "deposit_list": "Deposits",
      "ticket_informations": "Ticket informations",
      "ticket_history": "Ticket history",
      "ticket_additional_costs": "Additional costs",
      "to_edit_advantages": "Edit advantages",
      "signing": "Signing",
      "signing_sheet": "Signing sheet",
      "non_compliance": "Non Compliance",
      "expenses": "Expense reports",
      "deposit": "Deposit",
      "deposit_infos": "Deposit informations",
      "upsell_dqc": "Analytics"
    },
    "space_name": "{name}'s Space"
  },
  "roles": {
    "label": "Roles",
    "initiator": "Initiator",
    "validator-1": "Validator 1",
    "validator-2": "Validator 2",
    "admin": "Admin (deprecated)",
    "analytics-admin": "Analytics admin",
    "contact-admin": "Contact admin",
    "super-admin": "Super admin",
    "ticket-admin": "Ticket admin",
    "user-admin": "User admin",
    "declaration-admin": "Simple declaration admin",
    "admin-analytics-dqc": "Admin DQC user",
    "admin-analytics-dqc-editor": "Admin DQC editor",
    "admin-analytics-dqc-manager": "Admin DQC manager",
    "conventions-admin": "Simplified conventions admin"
  },
  "inputs": {
    "types": {
      "select": "Select menu",
      "checkbox": "Checkbox"
    },
    "ticket_name": {
      "label": "Event's name"
    },
    "internal_tracking_code_name": {
      "label": "Internal code"
    }
  },
  "filter": "Filter",
  "list": {
    "no_result": "No result"
  },
  "analytics": {
    "error": "Your data will be displayed here",
    "bi": {
      "title": "Analytics - BI",
      "tabs": {
        "dashboard": "General",
        "performance": "Performance",
        "alert": "Alerts",
        "comparative_analysis": "Comparative analysis"
      }
    }
  },
  "submissions": {
    "title": "Submissions"
  },
  "workflow_step_and_status": {
    "creating": "Creating",
    "first_validation": "First validation",
    "second_validation": "Second validation",
    "to_edit": "To modify",
    "validating": "Being validated",
    "contract_management": "In submission & management",
    "event_in_progress": "Event in progress",
    "event_validating": "Expenses validation",
    "event_is_finished": "Event is finished",
    "canceled": "Canceled"
  },
  "items": "items",
  "properties": "Properties"
}
